enum selectColorEnum {
	white = 'white',
	grey = 'grey'
}

export default selectColorEnum